import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MessageService } from '../../../../../core';
import { PedidoFilter } from '../../../../pedido/filter/pedido-filter';
import { PedidoPedidoListComponent } from '../../../../pedido/pedido/list/pedido-pedido-list.component';
import { PedidoSearch } from '../../../../pedido/pedido-search';
import { pedidoNaoLiberado } from '../../../../pedido/status';
import { CampanhaFilter } from '../../filter';
import { referenciaDataEmissao } from '../../../../pedido/referencia-data';

@Component({
    selector: 'sgt-campanha-pedido-nao-liberado-view',
    templateUrl: './campanha-pedido-nao-liberado-view.component.html',
    styleUrls: ['./campanha-pedido-nao-liberado-view.component.less']
})
export class CampanhaPedidoNaoLiberadoViewComponent {
    @Input() idCampanha: number;
    @Input() filter: CampanhaFilter;

    @Output() afterLiberarPedido = new EventEmitter<void>();

    pedidoFilter = new PedidoFilter();
    @ViewChild('list') list: PedidoPedidoListComponent;

    constructor(private messageService: MessageService) { }

    /** Seta o filtro dos pedido */
    private setPedidoFilter() {
        this.pedidoFilter = new PedidoFilter(referenciaDataEmissao);

        // Campanha
        if (this.idCampanha > 0) {
            this.pedidoFilter.idsCampanhas = [this.idCampanha];
        } else if (this.idCampanha === -1) { // Sem Campanha
            this.pedidoFilter.idsCampanhas = null;
            this.pedidoFilter.campanhaNull = true;
        }

        // Periodividade da vigência da campanha
        this.pedidoFilter.periodicidadeVigencia = this.filter.periodicidadeVigencia;
        this.pedidoFilter.dataInicioVigencia = this.filter.dataInicioVigencia;
        this.pedidoFilter.dataTerminoVigencia = this.filter.dataTerminoVigencia;
        this.pedidoFilter.dataInicioVigenciaPeriodo = this.filter.dataInicioVigenciaPeriodo;
        this.pedidoFilter.dataTerminoVigenciaPeriodo = this.filter.dataTerminoVigenciaPeriodo;
        this.pedidoFilter.mesVigencia = this.filter.mesVigencia;
        this.pedidoFilter.trimestreVigencia = this.filter.trimestreVigencia;
        this.pedidoFilter.semestreVigencia = this.filter.semestreVigencia;
        this.pedidoFilter.anoVigencia = this.filter.anoVigencia;

        // Status Não Liberado
        this.pedidoFilter.status = [pedidoNaoLiberado.id];

        // Representantes
        this.pedidoFilter.idsRepresentantes = this.filter.idsRepresentantes;

        // Pessoas (Cliente promoção)
        this.pedidoFilter.idPessoaCampanha = this.filter.idPessoa;
    }

    /** Pesquisa os pedidos */
    search() {
        if (!this.idCampanha) {
            return
        }
        this.setPedidoFilter();
        setTimeout(() => this.list?.search(), 0);
    }

    /** Obtem os pedidos não liberados */
    getPedidos(): Promise<PedidoSearch[]> {
        return new Promise<PedidoSearch[]>(async (resolve) => {
            try {
                if (!this.idCampanha) {
                    resolve([]);
                }

                this.setPedidoFilter();
                const pedidos = await this.list.searchAll();
                resolve(pedidos);
            } catch (error) {
                this.messageService.error(error?.message ?? 'Erro ao obter os pedidos não liberados', error?.cause ?? 'Erro', error);
                resolve([]);
            }
        });
    }
}
